var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var ArrowChevronDownIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M5.00000164,12.9716182 C4.99923883,12.3099454 5.26395777,11.6799744 5.72650921,11.2426952 L16.1137046,1.43213168 C16.8295856,0.787231096 17.8940889,0.873827522 18.5112815,1.62717248 C19.1284741,2.38051744 19.0726006,3.5250542 18.3854379,4.2050083 L9.30223045,12.7836266 C9.25178963,12.8310937 9.22286488,12.8996072 9.22286488,12.9716182 C9.22286488,13.0436293 9.25178963,13.1121428 9.30223045,13.1596099 L18.3854379,21.7382282 C18.8635702,22.1689531 19.0868904,22.843918 18.9689828,23.5019392 C18.8510752,24.1599604 18.4104382,24.6978017 17.8175802,24.9073406 C17.2247222,25.1168795 16.5726561,24.9652417 16.1137046,24.5111048 L5.73023489,14.7035412 C5.26656377,14.2655132 5.00058813,13.6346883 5.00000164,12.9716182 Z", transform: "translate(12.000000, 13.000000) rotate(-90.000000) translate(-12.000000, -13.000000)" })))); };
export var ArrowChevronDown = styled(ArrowChevronDownIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=ArrowChevronDown.js.map